<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <img src="../../assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
      <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">{{ $t('SomethingIsntQuiteRight') }}</h1>
      <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text">{{ $t('ContentMissingOrNoPermissions') }}<br/>{{ $t('SubmitFeedbackIfError') }}</p>
      <vs-button size="large" to="/">{{ $t('BackToHome') }}</vs-button>
      <vs-button  color="primary" class="mt-5" type="border" @click="LogoutAndRedirect">{{ $t('LoginAndRetry') }}</vs-button>
    </div>
  </div>
</template>
<script>

  import accountsService from "@/accounts/accountsService";

  export default {
    data() {
      return {
        
      };
    },
    methods: {
      LogoutAndRedirect() {
        accountsService.cleanUserLocalStorageItems();
        window.location.href = "/pages/login?redirect_uri=" + this.$route.query.returnUrl + "&returnUrl=" + true;
      }
    }
  }
</script>
